import React, { useState, useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Container, Row, Col, Modal } from "react-bootstrap";
import {
  faPlus,
  faXmark,
  faCircle,
  faPaperclip,
  faBolt,
  faEllipsis,
  faLink,
  faCircleCheck,
} from "@fortawesome/free-solid-svg-icons";
import Slider from "react-slick";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Button from "react-bootstrap/Button";
import Dropdown from "react-bootstrap/Dropdown";
import Docmnt from "../../../../assets/images/google-docs.png";
import Arcv from "../../../../assets/images/archive.svg";
import Export from "../../../../assets/images/export.svg";
import edit from "../../../../assets/images/edit.png";
import Cargotruck from "../../../../assets/images/cargo-truck.png";
import Cuser from "../../../../assets/images/cuser.png";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { withoutRFSToken, withRFSToken } from "../../../../Services/axios.js";
import { UCMHISTORYGRID } from "../../../../Utils/conts.js";
import { jqxCookieCall } from "../../../../Components/common/CommonFunctions.js";

const MessageLog = () => {
  const [isLoading, setIsLoading] = useState(true);
  const isMounted = useRef(false);
  const [gridData, setGridData] = useState([
    {
      mvt_type: "UCM In",
      data_prcsed: "14:45",
      prcsed_by: "DemoHandler",
    },
    {
      mvt_type: "UCM In",
      data_prcsed: "14:45",
      prcsed_by: "DemoHandler",
    },
    {
      mvt_type: "UCM In",
      data_prcsed: "14:45",
      prcsed_by: "DemoHandler",
    },
    {
      mvt_type: "UCM In",
      data_prcsed: "14:45",
      prcsed_by: "DemoHandler",
    },
    {
      mvt_type: "UCM In",
      data_prcsed: "14:45",
      prcsed_by: "DemoHandler",
    },
  ]);
  const fetchDataGrid = async () => {
    try {
      const res = await withRFSToken
        .post(UCMHISTORYGRID, { history_type: "message" })
        .then(function (res) {
          const innerData = res.data.response_data.ulds;
          const innerDataCount = res.data.response_data.pagination;
          setGridData(innerData);
          // setTotalRows({
          //     pageSize: innerDataCount.page_size,
          //     currPage: innerDataCount.current_page,
          //     lastPage: innerDataCount.last_page,
          //     totalUlds: innerDataCount.total
          // });
        });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  useEffect(() => {
    // Call the fetchData function to fetch data from the API
    if (isMounted.current) return;
    // fetchDataGrid();
    setGridData([]);
    setIsLoading(false);
    isMounted.current = true;
  }, []);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [gridSelect, setGridSelect] = useState([]);
  const gridRef = useRef(null);

  // useEffect(() => {

  //     if (gridRef.current) {
  //         if (gridData) {
  //             const source = {
  //                 datatype: 'json',
  //                 id: '',
  //                 datafields: [
  //                     { name: 'id', type: 'string' },
  //                     { name: 'movement_type', type: 'string' },
  //                     { name: 'date_processed', type: 'string' },
  //                     { name: 'processed_by', type: 'string' },
  //                     { name: 'message_body', type: 'string' },
  //                 ],
  //                 localdata: gridData,
  //             };

  //             const dataAdapter = new window.$.jqx.dataAdapter(source);
  //             console.log('localdata', source.localdata)
  //             const columns = [
  //                 { text: 'Movement Type', filtertype: 'textbox', datafield: 'movement_type', width: '15%', cellclassname: '', },
  //                 { text: 'Date Processed', filtertype: 'textbox', datafield: 'date_processed', width: '15%', cellclassname: '', },
  //                 { text: 'Processed By', filtertype: 'textbox', datafield: 'processed_by', width: '15%', cellclassname: '', },
  //             ];

  //             const gridOptions = {
  //                 width: '100%',
  //                 source: dataAdapter,
  //                 columns: columns,
  //                 autoheight: true,
  //                 sortable: true,
  //                 altrows: false,
  //                 enabletooltips: true,
  //                 editable: false,
  //                 // selectionmode: 'checkbox',
  //                 pageable: true,
  //                 pageSize: 20,
  //                 pagerButtonsCount: 5,
  //                 pagerMode: 'advanced',
  //                 filterable: true,
  //                 filterrowheight: 45,
  //                 showfilterrow: true,
  //                 rowsheight: 42,
  //                 columnsheight: 45,

  //             };

  //             window.$(gridRef.current).jqxGrid(gridOptions);
  //             window.$(gridRef.current).find('.jqx-grid-column-header').css('background-color', 'white');

  //             window.$(gridRef.current).off('rowclick');
  //             window.$(gridRef.current).on('rowclick', (event) => {
  //                 console.log('event', event);
  //                 const args = event.args.row.bounddata;
  //                 console.log("🚀 ~ window.$ ~ args:", args)
  //                 // setSelectedRowData({ args, station_id: args.id });
  //                 const messageWithLineBreaks = args.message_body.replace(/\n/g, "<br>");
  //                 setSelectedRowData(messageWithLineBreaks);

  //             });
  //             window.$(gridRef.current).find('div[role="row"]').each((index, row) => {
  //                 window.$(row).on('mouseover', () => {
  //                     window.$(row).addClass('row-hover');
  //                 });
  //                 window.$(row).on('mouseout', () => {
  //                     window.$(row).removeClass('row-hover');
  //                 });
  //             });

  //         } else {
  //             const columns = [
  //                 { text: 'Stations', filtertype: 'textbox', datafield: 'STN', width: '50%' },
  //                 { text: 'Total Address', filtertype: 'textbox', datafield: 'Taddrs', width: '50%' },
  //             ];
  //         }
  //     }
  // }, [gridData, selectedRowData]);

  useEffect(() => {
    if (gridRef.current) {
      if (gridData) {
        // let token = "Bearer " + localStorage.ULD;
        jqxCookieCall()
        const source = {
          datatype: "json",
          id: "",
          datafields: [
            { name: "id", type: "string" },
            { name: "movement_type", type: "string" },
            { name: "date_processed", type: "date" },
            { name: "processed_by", type: "string" },
            { name: "message_body", type: "string" },
          ],
          url: `${process.env.REACT_APP_RFS_URL}uld-history/get-movement-history?history_type=message`,
          // beforeSend: function (jqXHR) {
          //   jqXHR.setRequestHeader("Authorization", token);
          // },
          pagesize: 20,
          filter: function (allfilters) {
            window.$(gridRef.current).jqxGrid("updatebounddata", "filter");
          },
          beforeprocessing: function (data) {
            source.totalrecords = data.TotalRows;
          },
          sort: function () {
            window.$(gridRef.current).jqxGrid("updatebounddata", "sort");
          },
          root: "ulds",
          cache: false,
        };
        const dataAdapter = new window.$.jqx.dataAdapter(source);
        const columns = [
          {
            text: "Movement Type",
            filtertype: "textbox",
            datafield: "movement_type",
            width: "15%",
            cellclassname: "",
          },
          {
            text: "Date Processed",
            filtertype: "range",
            datafield: "date_processed",
            width: "15%",
            cellclassname: "",
            cellsformat: 'dd-MM-yyyy',
          },
          {
            text: "Processed By",
            filtertype: "textbox",
            datafield: "processed_by",
            width: "15%",
            cellclassname: "",
          },
        ];
        const gridOptions = {
          width: "100%",
          source: dataAdapter,
          columns: columns,
          autoheight: true,
          sortable: true,
          altrows: false,
          enabletooltips: true,
          editable: false,
          pageable: true,
          pageSize: 20,
          pagesizeoptions: ["20", "50", "100", "200", "500"],
          pagerButtonsCount: 5,
          pagerMode: "advanced",
          filterable: true,
          filterrowheight: 45,
          showfilterrow: true,
          rowsheight: 42,
          columnsheight: 45,
          virtualmode: true,
          rendergridrows: function (params) {
            return params.data;
          },
        };
        window.$(gridRef.current).jqxGrid(gridOptions);
        window
          .$(gridRef.current)
          .find(".jqx-grid-column-header")
          .css("background-color", "white");
        window.$(gridRef.current).off("rowclick");
        window.$(gridRef.current).on("rowclick", (event) => {
          const args = event.args.row.bounddata;
          const messageWithLineBreaks = args.message_body.replace(
            /\n/g,
            "<br>"
          );
          setSelectedRowData(messageWithLineBreaks);
        });
        window
          .$(gridRef.current)
          .find('div[role="row"]')
          .each((index, row) => {
            window.$(row).on("mouseover", () => {
              window.$(row).addClass("row-hover");
            });
            window.$(row).on("mouseout", () => {
              window.$(row).removeClass("row-hover");
            });
          });
      } else {
        const columns = [
          {
            text: "Stations",
            filtertype: "textbox",
            datafield: "STN",
            width: "50%",
          },
          {
            text: "Total Address",
            filtertype: "textbox",
            datafield: "Taddrs",
            width: "50%",
          },
        ];
      }
    }
  }, [gridData]);

  const exportToExcel = () => {
    if (gridRef.current) {
      window.$(gridRef.current).jqxGrid("exportdata", "xls", "GridData");
    }
  };

  // +++++++++++++++++++ div +++++++++++++++++++++++++

  const [files, setFiles] = useState([]);
  const fileInputRef = useRef(null);

  const handleDrop = (e) => {
    e.preventDefault();
    const droppedFiles = Array.from(e.dataTransfer.files);
    setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDeleteFile = (index) => {
    setFiles((prevFiles) => {
      const newFiles = [...prevFiles];
      newFiles.splice(index, 1);
      return newFiles;
    });
  };

  const handleBrowseFiles = (e) => {
    e.preventDefault();
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    setFiles((prevFiles) => [...prevFiles, ...selectedFiles]);
  };

  // +++++++++++++++++++++++++++++++++++++++++++++++++++++ file upload

  const [html, setHtml] = useState("");

  function onChange(e) {
    setHtml(e.target.value);
  }

  // ++++++++++++++++++++++++++++++++++++++++++++ HTML EDITOR

  var settings = {
    dots: false,
    infinite: false,
    slidesToShow: 2,
    slidesToScroll: 1,
  };

  // +++++++++++++++++++++++++++++++++++ Silk Slider

  const [show, setShow] = useState(false);
  const [selectedFile, setSelectedFile] = useState("");

  const handleFileClick = (file) => {
    setSelectedFile(file);
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
    setSelectedFile("");
  };

  // ++++++++++++++++++++++++++++++++++++ Zoom Image
  const handleCloseClick = () => {
    setSelectedRowData(null);
  };

  return (
    <>
      {/* <div className="mb-3 nestedtabs rounded minh">
                <div className='d-flex justify-content-between'>
                    
                </div>
            </div>

            <div className='ulddown'>
                <button onClick={exportToExcel}><img src={Export} /> Download</button>
            </div> */}

      <div className="maindiv">
        <div className="trashdonload">
          {!isLoading && (
            <>
              <div ref={gridRef} className="bookinggrid"></div>
            </>
          )}
        </div>
        {selectedRowData && (
          <div className="SecondDiv w-50">
            {/* {console.log('55', selectedRowData)} */}
            <button className="close" onClick={handleCloseClick}>
              {" "}
              <FontAwesomeIcon icon={faXmark} />{" "}
            </button>
            <div className="girddtals_header">
              <h3>Message</h3>
              <p dangerouslySetInnerHTML={{ __html: selectedRowData }}></p>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default MessageLog;
